export default __webpack_public_path__ + "static/media/lab-conference.af03b765.svg";